// extracted by mini-css-extract-plugin
export default {"ImageCard":"imageCard_ImageCard__u25Y+","dragging":"imageCard_dragging__FlwtT"};